<template lang="pug">
v-app
  section
    header.d-flex.row.flex-row.align-items-end.mb-3
      .col-8
        router-link.button-previous.mr-2(:to="{path: '/administracion/id/scale-values-list', query: {restart: false}}")
          i.fas.fa-chevron-left
        h1.m-0.d-inline-block.align-middle
          i Editar Escala de Valor
      .col-4
        .h2.text-right.ad_text-grayLight.m-0
          i.text-capitalize
    section
      .d-flex.row.flex-row.align-items-start.mt-4
        .col-12
          .card.p-0.ad_bg-gray.rounded-xl
            .card-body
              form.d-flex.flex-row.flex-wrap
                .col-6.form-group.align-items-center.mb-4
                  label.col-3.pl-0.m-0 Nombre
                  input.col.form-control(type="text" v-model="name" maxlength='100' placeholder='ingresa nombre' title='ingresa tu nombre')
                .col-6.form-group.align-items-center.mb-4
                  label.col-3.pl-0.m-0 Descripción
                  textarea.form-control(v-model="description" maxlength='100' rows="3" placeholder='ingresa descripción' title='Descripción')
                  .col-auto.form-group.align-items-center.mb-0.pr-0
                .col-6.form-group.align-items-center.mb-4
                  label.col-3.pl-0.m-0 Indice
                  input.col.form-control(type="number" v-model="index" maxlength='100' placeholder='0' max="100" title='Meta')

          .d-flex.flex-row.mt-5
            router-link.stepper-button.previous(to="/administracion/id/scale-values-list")
              i.material-icons
              span Volver
            button.col-auto.stepper-button.next.ml-auto(@click="updateScaleValueManager()")
              span Actualizar
              i.material-icons


</template>

<script>
import { mapActions } from 'vuex';
import { nullLiteralTypeAnnotation } from 'babel-types';
export default {
  name: 'ScaleValuesEdit',
  data () {
    return {
      scalevalue: null,
      name: null,
      description: null,
      index: null
    }
  },
  methods: {
    ...mapActions('scalevalues', [
      'getScaleValueById', 'updateScaleValue'
    ]),
    setScaleValueProps() {      
      const vm = this      
      try {
        vm.name = vm.scalevalue.name
        vm.description = vm.scalevalue.description
        vm.index = vm.scalevalue.index
      } catch (e) {
        vm.notify(e)
        console.info(e)
      }
    },
    getScaleValuesFromProps() {
      const vm = this
      return {
        id: vm.scalevalue._id,
        name: vm.name,
        description: vm.description,
        suggested_plan: vm.index
      }
    },
    loadDetail(id) {
      const vm = this
      const loading = vm.$toast.loading('Cargando Detalle...')      
      vm.getScaleValueById(id).then((scalevalue) => {
        vm.scalevalue = vm.$store.getters['scalevalues/getScaleValue'];
        vm.setScaleValueProps()
        loading.hide()
      }).catch(error => {
        vm.notify(error)
        loading.hide()
      })
    },
    notify(error = true, message) {
      const vm = this
      vm.$notify({
          type: error ? 'danger' : 'success',
          title: 'Notificación',
          content: message,
          closeable: true,
          duration: 5000
        })
    },
    updateScaleValueManager() {
      const vm = this
      const loading = vm.$toast.loading('Guardando...')
      if (vm.validate()) {
        const data = vm.getScaleValuesFromProps()
        vm.updateScaleValue(data).then(result => {
          if (!result.success) {
            loading.hide()
            vm.notify(true, result.message)
          } else {
            loading.hide()
            vm.notify(false, 'Escala actualizado')
          }
        }).catch(error => {
          loading.hide()
          vm.notify(true, error.payload.message)
        })
        loading.hide()
      } else {
        loading.hide()
      }
    },
    isValidInput(input) {
      return input !== undefined && input !== null
    },
    isValidInputPer(input) {
      return input >= 0 && input <= 100
    },
    isValidBoolean(input) {
      return input === false || input === true
    },
    validate() {
      const vm = this
      let valid = true
      let missing = ''
      if (!vm.isValidInput(vm.name)) {
        missing = 'Debe completar el campo nombre'
        valid = false
      } else if (!vm.isValidInput(vm.description)) {
        missing = 'Debe completar el campo descripción'
        valid = false
      } else if (!vm.isValidInputPer(vm.index)) {
        missing = 'Debe completar el campo indice'
        valid = false
      }

      if (valid) {
        return true
      } else {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: missing,
          closeable: true,
          duration: 5000
        })
        return false
      }
    }
  },
  mounted() {
    const vm = this;
    vm.loadDetail(this.$route.params.id)
    this.$emit('can-continue', { value: true })
  }
}
</script>

<style lang="css" scoped></style>


// WEBPACK FOOTER //
// src/views/scale-values/scale-values-edit.vue